import {
	Request,
	Response
} from './wsclasses'

const ADDR = 'p0.tv.kvant-telecom.ru:8060/';
let ws = null; //websocket client
let rid = 0; //request id
let callbacks = {}; //handlers for responses

function init(val, exit, err, menuButton) {
	window.ws = new WebSocket('wss://' + ADDR, 'protocol1');

	window.ws.onopen = function (event) {
		console.log(event);
		console.log('Соединение установлено.');
		val.push('/auth');
		err.val = true;
	};

	window.ws.onclose = function (event) {
		if (event.wasClean) {
			console.log(event);
			console.log('Соединение закрыто нормально');
			err.val = false;
			exit.val = 'Вход';
			menuButton.val = false;
			window.ws = null;
			setTimeout(function () {
				init(val, exit, err, menuButton)
			}, 1000);
		} else {
			console.log(event);
			console.log('Обрыв соединения с сервером!!!');
			err.val = false;
			exit.val = 'Вход';
			menuButton.val = false;
			window.ws = null;
			setTimeout(function () {
				init(val, exit, err, menuButton)
			}, 1000);
		}
	};

	window.ws.onmessage = function (event) {
		processResponse(event.data);
	};

	window.ws.onerror = function (error) {
		console.log('Error: ' + error.message);
	};

}

// ----------------------------------------------------------------------------------------


function processResponse(message) {
	let response = JSON.parse(message);
	console.log(response);

	if (callbacks[response.id] !== undefined) {

		callbacks[response.id](response);
	}

	if (response.code === Response.ERROR) {
		console.log('Сервер говорит - неверный запрос: ' + response.id);
	}

	delete callbacks[response.id];
}

function performRequest(command, data, handler) {

	let request = new Request();
	request.command = command;
	request.data = data;
	// increase request counter
	request.id = rid++;
	callbacks[request.id] = handler;

	console.log('Requesting:');
	console.log(request);
	window.ws.send(JSON.stringify(request));

}

export {
	performRequest,
	init
}



// WEBPACK FOOTER //
// ./src/script/ws/wsclient.js